import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LegalDocumentsList from './LegalDocumentsList';
import LegalDocumentForm from './LegalDocumentForm';
import LegalDocumentDetails from './LegalDocumentDetails';
import VersionHistory from './VersionHistory';
import TenantAcceptanceStatus from './TenantAcceptanceStatus';

const LegalDocuments = () => {
  return (
    <Routes>
      <Route path="/" element={<LegalDocumentsList />} />
      <Route path="/create" element={<LegalDocumentForm />} />
      <Route path="/edit/:id" element={<LegalDocumentForm />} />
      <Route path="/details/:id" element={<LegalDocumentDetails />} />
      <Route path="/versions/:documentType" element={<VersionHistory />} />
      <Route path="/tenant-acceptance/:tenantId?" element={<TenantAcceptanceStatus />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default LegalDocuments;